// src/pages/CategoryPage.jsx
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom"; // Import useParams to get URL parameters
import axios from "axios";
import PaintingOverview from "../components/PaintingOverview";
import "../assets/styles/overview.css"; // Assuming overview.css applies to all category displays

function CategoryPage() {
  // Use useParams to get the categoryName from the URL
  const { categoryName } = useParams();

  const [paintings, setPaintings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Define the backend URL using an environment variable
  // This will be picked up from Vercel's environment variables (e.g., REACT_APP_BACKEND_URL)
  // The fallback is for local development if the env var isn't set
  const BACKEND_URL =
    process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

  useEffect(() => {
    const fetchPaintingsByCategory = async () => {
      setLoading(true); // Set loading to true whenever category changes
      setError(null); // Clear previous errors

      try {
        // CORRECTED AXIOS CALL: Use the full backend URL
        const response = await axios.get(`${BACKEND_URL}/api/painting`);
        console.log(
          `Fetched paintings for category "${categoryName}":`,
          response.data
        );

        const allPaintings = response.data;

        // Filter paintings based on the dynamic categoryName from the URL
        const filteredPaintings = allPaintings.filter(
          (painting) => painting.category === categoryName
        );
        const sortedPaintings = filteredPaintings.sort(
          (a, b) => a.order - b.order
        );

        setPaintings(sortedPaintings);
      } catch (err) {
        console.error(
          `Error fetching paintings for category "${categoryName}":`,
          err
        );
        if (err.response) {
          setError(
            new Error(
              `Server Error: ${err.response.status} - ${
                err.response.data.message || "Unknown server error"
              }`
            )
          );
        } else if (err.request) {
          setError(
            new Error(
              "Network Error: No response received from server. Is the backend running?"
            )
          );
        } else {
          setError(new Error(`Request Error: ${err.message}`));
        }
      } finally {
        setLoading(false);
      }
    };

    fetchPaintingsByCategory();
    // Re-run effect when categoryName or BACKEND_URL changes
  }, [categoryName, BACKEND_URL]); // <--- BACKEND_URL added here

  if (loading) {
    return <div>Loading {categoryName} paintings...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      {/* Pass the categoryName directly to PaintingOverview */}
      <PaintingOverview paintings={paintings} category_name={categoryName} />
    </>
  );
}

export default CategoryPage;
